export default __webpack_public_path__ + "static/media/ppl-quote-light.01577e63.svg";